import { useParams } from "react-router-dom";
import BlockNote from "./BlockNotes";
import { RoomProvider } from "../liveblocks.config";
import { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import CryptoJS from 'crypto-js'
import { useNavigate } from "react-router-dom";
import '../css/BlockNote.css'
import { Alert, Breadcrumbs, Card } from "@mui/material";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShareFromSquare } from '@fortawesome/free-regular-svg-icons'

import Tooltip from '@mui/material/Tooltip';

import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Snackbar from '@mui/material/Snackbar';
import Skeleton from '@mui/material/Skeleton';
import LZString from "lz-string";

const handleCompress = (text) => {
  const compressed = LZString.compressToBase64(text);
  return compressed;
};

const handleDecompress = (text) => {
  const decompressed = LZString.decompressFromBase64(text);
return decompressed
};

const decrypt = (text, privateKey, public_key) => {
  const decrypted = CryptoJS.AES.decrypt(text, CryptoJS.enc.Hex.parse(privateKey), {
    iv: CryptoJS.enc.Hex.parse(public_key),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);

  return decrypted;
};
export default function BlockNoteHandler(props) {
  const navigate = useNavigate()
    const {
        clientId,
        sessionId,
        encrypt,
        colorScheme,
        updateTab,
        findNotePath,
        addr,
        allFiles,
        editorNames,
        findNameById,
        globalEditors,
        value,
        username,
      } = props;
      const {noteId} = useParams()
      const [showEditor, setShowEditor] = useState(true)
      const [globalNotes, setGlobalNotes] = useState([])
      const [ws, setWs] = useState(false)
      const [socket, setSocket] = useState(null)
      const [wsClose, setWsClose] = useState(false)
      const [noteName, setNoteName] = useState()
      const [initialized, setInitialized] = useState(false)
      const [room, setRoom] = useState(null)
      const [openSnack, setOpenSnack] = useState(false)
      const [snackMsg, setSnackMsg] = useState(null)
      const [open, setOpen] = useState(true)
  const [notePath, setNotePath] = useState([])
      const [privateKey, setPrivateKey] = useState(null)
      const [publicKey, setPublicKey] = useState(null)
      const [globalNoteContent, setGlobalNoteContent] = useState(null)
      const [instance, setInstance] = useState(1);

      
      useEffect(()=>{
        
    const name = findNameById(globalNotes, noteId)
    setNoteName(name)
    setNotePath(findNotePath(noteId).slice().reverse())
      }, [noteId, allFiles])
      function sendMessage(msg) {
        if(ws) {
          setOpen(true)
          setWsClose(false)
          if (ws.readyState !== WebSocket.CLOSED) {

          ws.send(JSON.stringify(msg))
          }else {
            setOpen(false)
          }
        }else {
          setWsClose(true)
        }
      }
      useEffect(()=>{
        setGlobalNotes(allFiles.filter(file => file.type === 'note'))
      },[allFiles])
      //!Websocket! 
      
      useEffect(() => {
        setShowEditor(false)
        
        setShowEditor(false)
        const showTO = setTimeout(()=>{
        }, 550)
        let socketAddr = 'wss://donotes-server.com:5050';
        let newWs = new WebSocket(socketAddr);
        setSocket(newWs)
        newWs.onopen = () => {
          setWsClose(false)
          // INIT
          const message = {
            type: 'init',
            sessionId,
            clientId,
            noteId,
            username
          }
          newWs.send(JSON.stringify(message))
          setInitialized(false)
        };
        newWs.onmessage = (event) => {
          const message = event.data;
          try {
            const parsed = JSON.parse(message)
            if(parsed.type === 'note-data-from-server') {
              if(parsed.privateKey && parsed.publicKey && parsed.data) {
                setPrivateKey(parsed.privateKey)
                setPublicKey(parsed.publicKey)
                setRoom(parsed.room)
                let tempPrivate = parsed.privateKey
                let tempPublic = parsed.publicKey
                try {  
                  const decompressed = handleDecompress(parsed.data)
                  const data = decrypt(decompressed, tempPrivate, tempPublic)
                  
                  setGlobalNoteContent(data)
                  setShowEditor(true)
                }catch(error) {
                  console.error(error)
                }

              }
            }
            if(parsed.type === 'error') {
              console.error(parsed)
              if(parsed.message) {
                setOpenSnack(true)
                setSnackMsg(parsed.message)
              }
              if(parsed.action === 'home') {
                navigate('/')
              }
            }
            if(parsed.type === 'success-share') {
              setOpenSnack(true)
              setSnackMsg('Successfully shared note')
            }
          }catch(error) {
            console.log(event)
            console.error(error)
          }
        };
        newWs.onclose = () => {
          newWs = new WebSocket(socketAddr);
          
          setSocket(newWs)
          setWsClose(false)
          
        };
        setWs(newWs);
        return () => {
          try {
            
          newWs.close();
          }catch(e) {}
          try {
          ws.close()
          
        }catch(e) {}
        try {
          socket.close()
          
        }catch(e) {}
        clearTimeout(showTO)
        }; 
      }, [noteId, instance]);


      
    return (    
        <ErrorBoundary>
          <Snackbar
          open={openSnack}
          autoHideDuration={6000}
          onClose={()=>{setOpenSnack(false)}}
          message={snackMsg}
        />
        {!open && <Alert severity="warning" >We lost connection to the server. Any work you do now may not be saved. <md-filled-tonal-button onClick={()=>{
            setInstance(instance + 1)}}>Reconnect?</md-filled-tonal-button></Alert>}
        {
            (showEditor && room !== null) ?
            <BlockNote 
                globalEditors={globalEditors} 
                editorNames={editorNames} 
                addr={addr}
                globalNotes={globalNotes} 
                value={value} 
                findNotePath={findNotePath} 
                updateTab={updateTab} 
                findNameById={findNameById} 
                username={username} 
                noteId={noteId}
                clientId={clientId} 
                sessionId={sessionId}
                encrypt={encrypt} 
                colorScheme={colorScheme} 
                globalNoteContent={globalNoteContent} 
                privateKey={privateKey}
                publicKey={publicKey}
                wsClose={wsClose}
                ws={ws}
                initialized={initialized}
                setInitialized={setInitialized}
                setWsClose={setWsClose}
                room={room}
                sendMessage={sendMessage}
            />:
            <div style={{
            }}>
              
  <div className="topbar">
  <Breadcrumbs aria-label="breadcrumb">
        {notePath.map((item, index) => (
        <span key={index} color="inherit">
          {item}
        </span>
      ))}
      <span>
        {noteName}
      </span>
      </Breadcrumbs>
      <div style={{
        marginLeft: 'auto',
      }}>
      
      <AvatarGroup max={4} >
        {editorNames && editorNames.length > 0 && editorNames.map((edit, index) => (
        <Avatar key={index} alt={edit}>
          {edit[0]}
        </Avatar>
      ))}
      </AvatarGroup>
        
      </div>
      <Tooltip title="Share note" placement='top' arrow >
        <md-filled-button disabled>
        <FontAwesomeIcon slot="icon" icon={faShareFromSquare} />
          Share
        </md-filled-button>
        </Tooltip>
  </div>
  <div style={{
    paddingLeft: 50,
    paddingRight: 50,
    width: 'calc(100% - 100)',
  }}>
    
  <Skeleton animation="wave" sx={{
    height: 75,
    width: '60%',
    minWidth: 300,
  }} />
  
    
  <Skeleton animation="wave" height={50} width="50%" wsx={{
    minWidth: 250,
  }} />
  <Skeleton animation="wave" variant="rounded" height={300} width="100%" sx={{ minWidth: 300,
  }} />
    
  </div>
            </div>
        }
        
        </ErrorBoundary>
        )
}